import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Collapse,
  Switch,
  Link,
  Paper
} from '@mui/material';
import { Settings as SettingsIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const CookiesBanner = ({ onAccept }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [preferences, setPreferences] = useState({
    essential: true,
    analytics: true // Analytics enabled by default
  });

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after a short delay
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    const allAccepted = {
      essential: true,
      analytics: true
    };
    localStorage.setItem('cookieConsent', JSON.stringify(allAccepted));
    onAccept(allAccepted);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        borderRadius: '16px 16px 0 0',
        maxWidth: '100vw',
        bgcolor: 'background.paper'
      }}
    >
      <Box sx={{ p: 2 }}>
        <Box sx={{ mb: 1 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            {t('cookies.description')}{' '}
            <Link href="/cookies" target="_blank" rel="noopener noreferrer" sx={{ fontSize: 'inherit' }}>
              {t('cookies.cookiePolicy')}
            </Link>
          </Typography>
        </Box>

        <Collapse in={showSettings}>
          <Box sx={{ mb: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
              <Typography variant="body2" fontWeight="medium">
                {t('cookies.essential')}
              </Typography>
              <Switch
                checked={preferences.essential}
                disabled={true}
                size="small"
              />
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
              {t('cookies.essentialDescription')}
            </Typography>

            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
              <Typography variant="body2" fontWeight="medium">
                {t('cookies.analytics')}
              </Typography>
              <Switch
                checked={preferences.analytics}
                disabled={true}
                size="small"
              />
            </Box>
            <Typography variant="caption" color="text.secondary">
              {t('cookies.analyticsDescription')}
            </Typography>
          </Box>
        </Collapse>

        <Box 
          display="flex" 
          gap={1} 
          flexWrap="wrap" 
          justifyContent="space-between" 
          alignItems="center"
        >
          <Button
            startIcon={<SettingsIcon />}
            onClick={() => setShowSettings(!showSettings)}
            size="small"
            variant="text"
            sx={{ minWidth: 'auto' }}
          >
            {t('cookies.settings')}
          </Button>
          
          <Button
            onClick={handleAcceptAll}
            size="small"
            variant="contained"
            color="primary"
            sx={{ minWidth: 120 }}
          >
            {t('cookies.acceptAll')}
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default CookiesBanner;